import gql from "graphql-tag";

export const CREATE_ORGANIZATION_FEATURE = gql`
  mutation (
    $organizationId: ID!
    $config: InputFeatureConfig!
    $disabled: Boolean!
    $featureId: ID!
  ) {
    createOrganizationFeature(
      featureId: $featureId
      organizationId: $organizationId
      config: $config
      disabled: $disabled
    ) {
      id
      disabled
      config {
        ... on IncidentPriorityMatrix {
          incidentPriorityMatrix {
            name
            level
            commonSettings {
              createAutoTask
              approvalRequired
              incidentOpenIn
              incidentProgressIn
              incidentResolvedIn
              incidentReviewedIn
              inspectionRequired
            }
            incidentSettings {
              taskAssignmentRole
              assigneeForApprovalRole
              type
              notificationSettings {
                managerNotificationSettings {
                  managerRole
                  email
                  robocall
                  sms
                  slack
                  teams
                  summaryReportingSettings {
                    dailyConcerningActivity
                    dailyFacilitySummary
                    weeklyFacilitySummary
                    weeklyRegionalSummary
                  }
                }
              }
            }
          }
        }

        ... on IncidentEscalationMatrix {
          doorSensorConfigs {
            threshold
            sensorType
            doorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          motionSensorConfigs {
            sensorType
            authorization
            description
            organizationSubtype
            priority
            rentStatus
            renterStatus
            multi
            organizationType
            schedule
            threshold
            thresholdSign
            shortCode
          }
          temperatureSensorConfigs {
            threshold
            sensorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          humiditySensorConfigs {
            threshold
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          waterSensorConfigs {
            threshold
            sensorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
        }
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_FEATURE = gql`
  mutation UpdateOrganizationFeature(
    $id: ID!
    $organizationId: ID!
    $config: InputFeatureConfig!
  ) {
    updateOrganizationFeature(
      id: $id
      organizationId: $organizationId
      config: $config
    ) {
      id
      config {
        ... on IncidentPriorityMatrix {
          incidentPriorityMatrix {
            name
            level
            commonSettings {
              createAutoTask
              approvalRequired
              incidentOpenIn
              incidentProgressIn
              incidentResolvedIn
              incidentReviewedIn
              inspectionRequired
            }
            incidentSettings {
              taskAssignmentRole
              assigneeForApprovalRole
              type
              notificationSettings {
                managerNotificationSettings {
                  managerRole
                  email
                  robocall
                  sms
                  slack
                  teams
                  summaryReportingSettings {
                    dailyConcerningActivity
                    dailyFacilitySummary
                    weeklyFacilitySummary
                    weeklyRegionalSummary
                  }
                }
              }
            }
          }
        }
        ... on IncidentEscalationMatrix {
          doorSensorConfigs {
            threshold
            sensorType
            doorType
            thresholdSign
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          motionSensorConfigs {
            sensorType
            authorization
            organizationSubtype
            priority
            rentStatus
            renterStatus
            multi
            organizationType
            schedule
            threshold
            thresholdSign
            shortCode
          }
          temperatureSensorConfigs {
            threshold
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          humiditySensorConfigs {
            threshold
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          waterSensorConfigs {
            threshold
            sensorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
        }
        ... on OrganizationTenantDataProtection {
          pmsModules {
            tenantInfo {
              protectedFields {
                id
                field
                disabled
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_OVERRIDDEN_ORGANIZATION_FEATURE = gql`
  query GetOverriddenOrganizationFeature(
    $featureName: String
    $organizationId: ID!
  ) {
    overridenOrganizationFeature(
      featureName: $featureName
      organizationId: $organizationId
    ) {
      organization {
        id
        type
      }
      feature {
        id
      }
      config {
        ... on IncidentPriorityMatrix {
          incidentPriorityMatrix {
            name
            level
            commonSettings {
              createAutoTask
              approvalRequired
              incidentOpenIn
              incidentProgressIn
              incidentResolvedIn
              incidentReviewedIn
              inspectionRequired
            }

            incidentSettings {
              assigneeForApprovalRole
              taskAssignmentRole
              type
              notificationSettings {
                managerNotificationSettings {
                  managerRole
                  sms
                  email
                  robocall
                  sms
                  slack
                  teams
                  summaryReportingSettings {
                    dailyConcerningActivity
                    dailyFacilitySummary
                    weeklyFacilitySummary
                    weeklyRegionalSummary
                  }
                }
              }
            }
          }
        }
        ... on OrganizationTenantDataProtection {
          pmsModules {
            tenantInfo {
              protectedFields {
                id
                field
                disabled
              }
            }
          }
        }
        ... on VideoCameraIntegration {
          zoneVideoLinkEnabled
          zoneVideoLinkResendEnabled
        }
        ... on IncidentEscalationMatrix {
          doorSensorConfigs {
            threshold
            sensorType
            doorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
            canEditThreshold
          }
          motionSensorConfigs {
            sensorType
            authorization
            description
            organizationSubtype
            priority
            rentStatus
            renterStatus
            multi
            organizationType
            schedule
            threshold
            thresholdSign
            shortCode
          }
          zoneMotionConfigs {
            sensorType
            description
            organizationSubtype
            priority
            multi
            organizationType
            schedule
            threshold
            thresholdSign
            shortCode
          }
          temperatureSensorConfigs {
            threshold
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          humiditySensorConfigs {
            threshold
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
          waterSensorConfigs {
            threshold
            sensorType
            thresholdSign
            description
            organizationSubtype
            organizationType
            priority
            schedule
            shortCode
          }
        }
      }
    }
  }
`;

export const GET_TASK_RULES = gql`
  query GetTaskRules($organizationIds: [ID!]) {
    taskRules(organizationIds: $organizationIds) {
      id
      name
      startsAt
      endsAt
      code
      description
      conditions {
        event
        method
        vacancy_threshold
        target_below_threshold
        target_at_or_above_threshold
        fixed_target_units
        devices_per_unit
      }
      organization {
        id
        name
        type
        subtype
        facility: ancestors(type: "facility") {
          id
          name
        }
        organization: ancestors(type: "organization") {
          id
          name
        }
      }
      status
      priority
      frequency {
        dayOfMonth
        daysOfWeek
        interval
        monthOfYear
        type
      }
      taskType {
        id
        name
        status
      }
      organization {
        id
        name
        code
        type
        subtype
        externalId
      }
      actions {
        checklist {
          description
          required
        }
        photoVideoRequired
      }
      notificationPreference {
        notifyAssignment {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyTodo {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyOverdue {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
      }
    }
  }
`;

export const CREATE_TASK_RULE = gql`
  mutation CreateTaskRule(
    $name: String!
    $description: String
    $conditions: InputTaskRuleConditions
    $status: String!
    $priority: String
    $frequency: InputTaskRuleFrequency
    $taskTypeId: ID!
    $organizationId: ID!
    $notificationPreference: InputTaskNotificationPreference
    $actions: InputTaskRuleActions
    $startsAt: DateTime
    $endsAt: DateTime
  ) {
    createTaskRule(
      name: $name
      description: $description
      conditions: $conditions
      status: $status
      priority: $priority
      frequency: $frequency
      taskTypeId: $taskTypeId
      organizationId: $organizationId
      notificationPreference: $notificationPreference
      actions: $actions
      startsAt: $startsAt
      endsAt: $endsAt
    ) {
      id
      name
      description
      status
      priority
      conditions {
        event
        method
        vacancy_threshold
        target_below_threshold
        target_at_or_above_threshold
        fixed_target_units
        devices_per_unit
      }
      frequency {
        dayOfMonth
        daysOfWeek
        interval
        monthOfYear
        type
      }
      taskType {
        id
        name
      }
      notificationPreference {
        notifyAssignment {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyTodo {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyOverdue {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
      }
      actions {
        checklist {
          description
          required
        }
        photoVideoRequired
      }
      startsAt
      endsAt
    }
  }
`;

export const UPDATE_TASK_RULE = gql`
  mutation UpdateTaskRule(
    $id: ID!
    $name: String
    $description: String
    $status: String
    $priority: String
    $frequency: InputTaskRuleFrequency
    $taskTypeId: ID
    $notificationPreference: InputTaskNotificationPreference
    $actions: InputTaskRuleActions
    $startsAt: DateTime
    $endsAt: DateTime
    $conditions: InputTaskRuleConditions
  ) {
    updateTaskRule(
      id: $id
      name: $name
      description: $description
      status: $status
      priority: $priority
      frequency: $frequency
      taskTypeId: $taskTypeId
      notificationPreference: $notificationPreference
      actions: $actions
      startsAt: $startsAt
      endsAt: $endsAt
      conditions: $conditions
    ) {
      id
      name
      description
      status
      priority
      frequency {
        dayOfMonth
        daysOfWeek
        interval
        monthOfYear
        type
      }
      taskType {
        id
        name
      }
      notificationPreference {
        notifyAssignment {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyTodo {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyOverdue {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
      }

      conditions {
        event
        method
        vacancy_threshold
        target_below_threshold
        target_at_or_above_threshold
        fixed_target_units
        devices_per_unit
      }

      actions {
        checklist {
          description
          required
        }
        photoVideoRequired
      }
      startsAt
      endsAt
    }
  }
`;

export const FIND_TASK_RULE = gql`
  query FindTaskRule($id: ID!) {
    findTaskRule(id: $id) {
      id
      name
      description
      conditions {
        event
        method
        vacancy_threshold
        target_below_threshold
        target_at_or_above_threshold
        fixed_target_units
        devices_per_unit
      }
      status
      priority
      frequency {
        type
        interval
        daysOfWeek
        dayOfMonth
        monthOfYear
      }
      taskType {
        id
        name
        status
      }
      notificationPreference {
        notifyAssignment {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyOverdue {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
        notifyTodo {
          email
          managerRole
          robocall
          slack
          sms
          teams
          summaryReportingSettings {
            dailyConcerningActivity
            dailyFacilitySummary
            weeklyFacilitySummary
            weeklyRegionalSummary
          }
        }
      }
      actions {
        photoVideoRequired
      }
      code
      conditions
      endsAt
      insertedAt
      lastExecutedAt
      seqId
      startsAt
      updatedAt
      updatedBy
    }
  }
`;

export const TASK_TYPES = gql`
  query TaskTypes($sort: String, $status: String) {
    taskTypes(sort: $sort, status: $status) {
      id
      name
      status
    }
  }
`;
export const EXTRACT_TASK_CHECKLIST = gql`
  mutation extractTaskChecklist($hasHeader: Boolean!, $file: Upload!) {
    extractTaskChecklist(hasHeader: $hasHeader, file: $file)
  }
`;
